import React, { useState, useRef, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { toast } from 'react-toastify';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function RenameDialog(props) {
  const [titleField, settitleField] = useState('');
  const [loading, setloading] = useState(false);

  useEffect(() => {
    if (props.renameAudioFileName || props.dialogState) {
      settitleField(props.renameAudioFileName);
    }
  }, [props.renameAudioFileName && props.dialogState]);

  const handleClose = () => {
    props.setdialogState(false);
  };

  const updateAudioTitle = async () => {
    if (!titleField || titleField === '') {
      toast.error(`Please provide the music title`, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return null;
    }
    setloading(true);
    props.setaudioFileNames([...props.audioFileNames, titleField]);

    let fileArr = [...props.imageFile];

    fileArr[props.imageFile.length - 1].name = titleField;
    props.setimageFile(fileArr);
    setloading(false);
    handleClose();
  };

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      style={{ zIndex: 1000 }}
      maxWidth="sm"
    >
      <div className="dialog-titlebar-medium">
        <div className="dialog-title-medium">Update Track Title</div>
        <div className="dialog-close-medium">
          <button
            className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
            type="button"
            onClick={handleClose}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <DialogContent>
        <div>
          <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">
            Title
          </label>
          <input
            onChange={(e) => {
              settitleField(e.target.value);
            }}
            type="text"
            placeholder="Enter your Display Name"
            required
            className="font-text border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow-lg focus:outline-none focus:ring w-full ease-linear transition-all duration-150 mb-4"
            pattern=".*\S+.*"
            title="This field is required"
            value={titleField}
            form="renameForm"
          />
        </div>
      </DialogContent>
      <DialogActions
        style={{
          marginTop: 10,
          height: 50,
        }}
      >
        <div
          style={{
            minWidth: 100,
            textAlign: 'center',
          }}
        >
          {(() => {
            if (loading) {
              return (
                <div className="flex justify-center	">
                  <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                </div>
              );
            } else {
              return (
                <button
                  className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                  onClick={() => {
                    updateAudioTitle();
                  }}
                >
                  Update
                </button>
              );
            }
          })()}
        </div>
      </DialogActions>
    </Dialog>
  );
}
